import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";
import { ExpirationSettingsRoutePaths } from "../expiration-settings-route-path";
import { PERMISSION_CONSTANTS } from "@app/shared/auth/constants/permissions.constant";

export const EXPIRATION_SETTING_SIDENAV_LINK = new InjectionToken<void>("EXPIRATION_SETTING_SIDENAV_LINK", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("setting", [
      {
        id: "expiration-settings",
        label: "EXPIRATION_SETTINGS",
        routerLink: `${ExpirationSettingsRoutePaths.ROOT}`,
        permissions: [
          PERMISSION_CONSTANTS.STOCK_EXPIRATION_SETTINGS.VIEW,
          PERMISSION_CONSTANTS.QUOTATION_EXPIRATION_SETTINGS.VIEW,
          PERMISSION_CONSTANTS.OCR_QUOTATION_EXPIRATION_SETTINGS.VIEW,
        ],
        icon: "alarm",
      },
    ]);
  },
});
